import Browser from '@mindful-web/marko-web/browser';
import Shared from '@encore360/package-global/browser';

Shared(Browser);

export default Browser;
